const networks = {
  awin: {
    name: "awin",
    id: process.env.AFFILIATE_AWIN_PUBLISHER_ID,
    enabled: process.env.AFFILIATE_awin === "true",
    buildLink: (merchantId, affiliateId, href) =>
      // Can have up to six clickref (clickref=one&clickref2=two&clickref3=three&clickref4=four&clickref5=five&clickref6=six)
      `https://www.awin1.com/cread.php?awinmid=${merchantId}&clickref=${encodeURIComponent("rm")}&awinaffid=${affiliateId}&ued=${encodeURIComponent(href)}`,
  },
};

export const affiliateMerchants = {
  bluetti: {
    displayName: "BLUETTI",
    name: "bluetti",
    id: 59271,
    regionMap: {
      US: 59271,
      AU: 32271,
      CA: 32269,
      DE: 32267,
      EU: 95479,
      FR: 32265,
      IT: 32261,
      MX: 118403,
      UK: 32273,
    },
    network: networks.awin.name,
    enabled: process.env.AFFILIATE_bluetti === "true",
  },
  bougerv: {
    displayName: "BougeRV",
    name: "bougerv",
    id: 52765,
    regionMap: { US: 52765 },
    network: networks.awin.name,
    enabled: process.env.AFFILIATE_bougerv === "true",
  },
  ecoflow: {
    displayName: "EcoFlow",
    name: "ecoflow",
    id: 59181,
    regionMap: {
      US: 59181,
      CA: 59181,
      DE: 51793,
      ES: 59181,
      EU: 59181,
      FR: 51799,
      IT: 59181,
      NL: 123332,
      UK: 51797,
      ZA: 59181,
    },
    network: networks.awin.name,
    enabled: process.env.AFFILIATE_ecoflow === "true",
  },
  jackery: {
    displayName: "Jackery",
    name: "jackery",
    id: 59183,
    regionMap: { US: 59183 },
    network: networks.awin.name,
    enabled: process.env.AFFILIATE_jackery === "true",
  },
  nilight: {
    displayName: "Nilight",
    name: "nilight",
    id: 84293,
    regionMap: { US: 84293 },
    network: networks.awin.name,
    enabled: process.env.AFFILIATE_nilight === "true",
  },
};

export const affiliateNetworks = {};
Object.values(networks).forEach((network) => {
  if (network.enabled) {
    affiliateNetworks[network.name] = {
      id: network.id,
      merchants: {},
      buildLink: network.buildLink,
    };

    // Add merchants belonging to this network
    Object.values(affiliateMerchants).forEach((merchant) => {
      if (merchant.enabled && merchant.network === network.name) {
        affiliateNetworks[network.name].merchants[merchant.name] = merchant.id;
      }
    });
  }
});
